import {
  Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, Autocomplete,
  TableHead, TableRow, Typography, TextField, Select, MenuItem, Grid, TablePagination,
  InputLabel, FormControl, Checkbox, ListItemText, Dialog, DialogTitle,Snackbar,
  DialogContent, DialogActions, useMediaQuery, FormHelperText
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import ChatIcon from '@mui/icons-material/Chat'
import { useTheme } from '@mui/material/styles'
import { useEffect, useState, useRef } from 'react'
import { useUserAuth } from '../context/UserAuthContext'
import MainLayout from '../layout/MainLayout'
import axios from 'axios'
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import QrCodeIcon from '@mui/icons-material/QrCode'; // Ícono de QR

// import QRCode from 'qrcode.react'; // Librería para generar QR


export const UserCaseritosPage = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { user } = useUserAuth()

  const [caseritos, setCaseritos] = useState([])
  const [filtered, setFiltered] = useState([])
  const [palabrasProhibidas, setPalabrasProhibidas] = useState([]);

  const [form, setForm] = useState({})
  const [modalOpen, setModalOpen] = useState(false)
  const [editing, setEditing] = useState(null)
  const [errors, setErrors] = useState({})
  const [reloadTrigger, setReloadTrigger] = useState(0);

  const [formMSN, setFormMSN] = useState({})
  const [modalMSNOpen, setModalMSNOpen] = useState(false)
  const [editingMSN, setEditingMSN] = useState(null)
  const [errorsMSN, setErrorsMSN] = useState({})

  const [filterName, setFilterName] = useState('')
  const [filterGenders, setFilterGenders] = useState([])
  const [filterSegmentations, setFilterSegmentations] = useState([])

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  
  const fetchPalabrasProhibidas = async () => {
    try {
    
        const payload = {
          Id: '',
          Status: 'ACTIVE'
        }

        const res = await axios.post(process.env.REACT_APP_GET_BLACKWORDS_GET_URL, payload)
        // console.log('Palabras prohibidas activas:', res.data);
        const vpalabrasProhibidas  = res.data
            .filter(item => item.Status === "ACTIVE")
            .map(item => ({
            text: item.Words,
            isRegex: /[\\^$*+?.()|[\]{}]/.test(item.Words) // Detecta si parece regex
          }));
          // console.log('Palabras prohibidas activas:', vpalabrasProhibidas);
          setPalabrasProhibidas(vpalabrasProhibidas );
  } catch (error) {
    console.error('Error al obtener Palablas prohibidas:', error)
  }

  };
  
  
  const regexFromString = (strWithFlags) => {
  const pattern = strWithFlags
    .replace(/^\/|\/[a-z]*$/g, ''); // Remueve / al inicio y /flags al final
  return new RegExp(pattern, 'i');
};
  const validarPalabraProhibida = (mensaje, listaProhibida) => {
  const mensajeLower = mensaje.toLowerCase();
  
  for (const item of listaProhibida) {
    try {
      if (item.isRegex) {
        // Para expresiones regulares
        const regex = new RegExp(item.text, 'i'); // 'i' para case insensitive
        if (regex.test(mensaje)) {
          return item.text; // Devuelve el patrón que coincidió
        }
        else
        {
          console.log(`No se encontró coincidencia para la expresión regular: ${item.text}`);
        }
      } else {
        // Para texto normal
        if (mensajeLower.includes(item.text.toLowerCase())) {
          return item.text;
        }
      }
    } catch (e) {
      console.error(`Error al procesar expresión regular: ${item.text}`, e);
    }
  }
  
  return null;
};

  const handleChangePage = (event, newPage) => {
  setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  const paginatedData = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

  const genders = ['HOMBRE', 'MUJER']
  const segmentations = ['SEMANALES', 'GOLONGRINOS', 'FUGADOS']

  const getCaseritos = async (filters = {}) => {
  const payload = {
    Id: '0',
    ClientCode: user.clientCode,
    FirstName: filters.FirstName || null,
    SecondName1: null,
    SecondName2: null,
    Phone: null,
    Gender: filters.Gender?.length === 1 ? filters.Gender[0] : null,
    Segmentation: filters.Segmentation?.length === 1 ? filters.Segmentation[0] : null,
    Address: null,
    AddressDistrict: null,
    AddressStreet: null,
    AddressNumber: null,
    AddressGeolocation: null,
    Status: 'ACTIVE'
  }

  try {
    
    const res = await axios.post(process.env.REACT_APP_GET_CUSTOMER_GET_URL, payload)
    
    setCaseritos(res.data)
  } catch (error) {
    console.error('Error al obtener caseritos:', error)
  }
}

  useEffect(() => {
  getCaseritos({
    FirstName: filterName,
    Gender: filterGenders,
    segmentation: filterSegmentations
  })
  fetchPalabrasProhibidas();
  setErrors({}); // Limpiar errores al abrir
}, [filterName, filterGenders, filterSegmentations, reloadTrigger])

  useEffect(() => {
    applyFilters()
  }, [caseritos, filterName, filterGenders, filterSegmentations])

  const applyFilters = () => {
    let result = [...caseritos]

    if (filterName) {
      // const term = filterName.toLowerCase()
      // result = result.filter(c =>
      //   `${c.FirstName} ${c.SecondName1} ${c.SecondName2}`.toLowerCase().includes(term)
      // )
      const term = filterName.toLowerCase()
        result = result.filter(c =>
          Object.values(c).some(value =>
            String(value).toLowerCase().includes(term)
          )
        )
    }

    if (filterGenders.length > 0) {
      result = result.filter(c => filterGenders.includes(c.Gender))
    }

    if (filterSegmentations.length > 0) {
      result = result.filter(c => filterSegmentations.includes(c.Segmentation))
    }

    setFiltered(result)
  }

  const confirmDelete = (item) => {
  setItemToDelete(item)
  setDeleteOpen(true)
}

const handleConfirmDelete = async () => {
  if (itemToDelete) {
    // await axios.delete(`/api/caseritos/${itemToDelete.Id}`)
    await axios.delete(`${process.env.REACT_APP_GET_CUSTOMER_DELETE_URL}/${itemToDelete.Id}`)
    setCaseritos(prev => prev.filter(p => p.Id !== itemToDelete.Id))

    setSnackbarMessage(`"${itemToDelete.Names}" ha sido eliminado correctamente`)
    setSnackbarOpen(true)
  }
  setDeleteOpen(false)
  setItemToDelete(null)
}

const handleEdit = (item) => {
    setErrors({}); // Limpiar errores al abrir
    setEditing(item)
    setForm(item)
    setModalOpen(true)
  }

  const handleSave = async () => {
  const newErrors = {}

  if (!form.FirstName || form.FirstName.trim() === '') {
    newErrors.FirstName = 'El nombre es obligatorio'
  } else if (form.FirstName.length > 30) {
    newErrors.FirstName = 'Máximo 30 caracteres'
  }

  if (!form.SecondName1 || form.SecondName1.trim() === '') {
    newErrors.SecondName1 = 'El apellido paterno es obligatorio'
  } else if (form.SecondName1.length > 30) {
    newErrors.SecondName1 = 'Máximo 30 caracteres'
  }

  if (form.SecondName2 && form.SecondName2.length > 30) {
    newErrors.SecondName2 = 'Máximo 30 caracteres'
  }

  if (!form.Phone || form.Phone.trim() === '') {
    newErrors.Phone = 'El teléfono es obligatorio'
  } else if (!/^\d{9}$/.test(form.Phone)) {
    newErrors.Phone = 'Debe tener exactamente 9 dígitos numéricos'
  }
  if (!form.Gender) {
    newErrors.Gender = 'Debe seleccionar un género'
  }
  if (!form.Segmentation) {
    newErrors.Segmentation = 'Debe seleccionar una segmentación'
  }

  setErrors(newErrors)

  if (Object.keys(newErrors).length > 0) return // ⛔ no guardar si hay errores

  // ✅ si pasa la validación, guarda
  form.ClientCode = user.clientCode;
  if (editing) {
     const res = await axios.post(process.env.REACT_APP_GET_CUSTOMER_UPDATE_URL, form)
     const nuevoCaserito = res.data
     console.log('Nuevo caserito actualizado:', nuevoCaserito)
      setCaseritos(prev => [...prev, nuevoCaserito])
       setSnackbarMessage(`"${nuevoCaserito.Names}" ha sido Actualizado correctamente`)
  } else {
     const res = await axios.post(process.env.REACT_APP_GET_CUSTOMER_CREATE_URL, form)
     const nuevoCaserito = res.data
     console.log('Nuevo caserito creado:', nuevoCaserito)
     setCaseritos(prev => [...prev, nuevoCaserito])
      setSnackbarMessage(`"${nuevoCaserito.Names}" ha sido Creado correctamente`)
  }

 
  setSnackbarOpen(true)

  setModalOpen(false)
  setEditing(null)
  setForm({})
  setErrors({})
  setReloadTrigger(prev => prev + 1);
}
  
function filtrarYTransformarCaseritos(caseritos, filtro) {

  // console.log('Caseritos antes del filtro:', caseritos);
  // Extraemos los valores permitidos de los filtros
  const generosPermitidos = new Set(filtro.GenderMSN || []);
  const segmentacionesPermitidas = new Set(filtro.SegmentationMSN || []);
  const IdPermitidos = new Set((filtro.CaseritosMSN || []).map(c => c.Id));

    // console.log('Generos permitidos:', generosPermitidos);
    // console.log('Segmentaciones permitidas:', segmentacionesPermitidas);
    // console.log('Id permitidos:', IdPermitidos);

  return caseritos
    .filter(caserito => {
      return (
        generosPermitidos.has(caserito.Gender) 
        && segmentacionesPermitidas.has(caserito.Segmentation) 
        && IdPermitidos.has(caserito.Id) 
      );
    })
    .map((caserito) => ({
      DestinationId: caserito.Phone, // Numeración consecutiva como string
      LogMessage: '', // Mensaje vacío como especificaste
      Status: 'ACTIVE',
    }));
}

const handleSaveMSN = async () => {
  const newErrors = {}
  // console.log('formMSN:', formMSN);

  if (!formMSN.Mensaje || formMSN.Mensaje.trim() === '') {
    newErrors.Mensaje = 'El Mensaje es obligatorio';
  } else if (formMSN.Mensaje.length > 300) {
    newErrors.Mensaje = 'Máximo 300 caracteres';
  } else {
    // Verificar palabras prohibidas
    const palabraEncontrada = validarPalabraProhibida(formMSN.Mensaje, palabrasProhibidas);
    
    if (palabraEncontrada) {
      newErrors.Mensaje = `El mensaje contiene una palabra no permitida: ${palabraEncontrada}`;
    }
  }

  if (!formMSN.GenderMSN || formMSN.GenderMSN.length === 0) {
    newErrors.GenderMSN = 'Debe seleccionar un género'
  }
  if (!formMSN.SegmentationMSN || formMSN.SegmentationMSN.length === 0) { 
    newErrors.SegmentationMSN = 'Debe seleccionar una segmentación'
  }
  if (!formMSN.CaseritosMSN || formMSN.CaseritosMSN.length === 0) {
    newErrors.CaseritosMSN = 'Debe seleccionar al menos un caserito'
  }

const resultadofiltro = filtrarYTransformarCaseritos(caseritos, formMSN);
console.log('resultadofiltro:', resultadofiltro);
  const payload = {
    MessageShopManId: user.clientCode,
    Message: formMSN.Mensaje,
    Destinations: resultadofiltro,
    Status: 'ACTIVE'
  }

  console.log('Payload para enviar mensaje:', payload);

  setErrorsMSN(newErrors)

  if (Object.keys(newErrors).length > 0) return // ⛔ no guardar si hay errores

       const res = await axios.post(process.env.REACT_APP_SAVE_SHOPMANMESSAGE_CREATE_URL, payload)
     const result = res.data

  setSnackbarMessage('Mensaje enviado correctamente')
  setSnackbarOpen(true)

  


  // // ✅ si pasa la validación, guarda
  // if (editing) {
  //    const res = await axios.post(process.env.REACT_APP_GET_CUSTOMER_UPDATE_URL, form)
  //    const nuevoCaserito = res.data
  //    console.log('Nuevo caserito actualizado:', nuevoCaserito)
  //     setCaseritos(prev => [...prev, nuevoCaserito])
  // } else {
  //    const res = await axios.post(process.env.REACT_APP_GET_CUSTOMER_CREATE_URL, form)
  //    const nuevoCaserito = res.data
  //    console.log('Nuevo caserito creado:', nuevoCaserito)
  //    setCaseritos(prev => [...prev, nuevoCaserito])
  // }

  setModalMSNOpen(false)
  setEditingMSN(null)
  setFormMSN({})
  setErrorsMSN({})
}


  const url = "https://www.tu-pagina-web.com"; // URL a la que redirigirá el QR
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

const [snackbarOpen, setSnackbarOpen] = useState(false)
const [snackbarMessage, setSnackbarMessage] = useState('')

const [deleteOpen, setDeleteOpen] = useState(false)
const [itemToDelete, setItemToDelete] = useState(null)

const [addressOptions, setAddressOptions] = useState([])
const [addressInput, setAddressInput] = useState('')

useEffect(() => {
  const fetchAddresses = async () => {
    if (addressInput.length < 3) return
console.log('Buscando direcciones para:', process.env.REACT_APP_GET_OPENSTREETMAP_GET_URL)
    try {
      const response = await axios.get(`${process.env.REACT_APP_GET_OPENSTREETMAP_GET_URL}`, {
  params: { q: addressInput }
})

      const suggestions = response.data.map(item => ({
        label: item.display_name,
        value: item.display_name,
        lat: item.lat,
        lon: item.lon,
      }))

      setAddressOptions(suggestions)
    } catch (error) {
      console.error('Error al buscar direcciones:', error)
    }
  }

  const timer = setTimeout(fetchAddresses, 400)
  return () => clearTimeout(timer)
}, [addressInput])

  return (
        <MainLayout access='user'>
    <Box sx={{ paddingLeft: '10px', paddingRight: '20px'}}>
        <Typography variant="h5" gutterBottom>Caseritos</Typography>

        {/* Filtros */}
        <Box
            display="flex"
            flexDirection={isMobile ? 'column' : 'row'}
            gap={isMobile ? 1 : 2} // Espacio entre filtros
          >
             <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={5}>
                  <TextField
                    label="Buscar caserito"
                    size="small"
                    value={filterName}
                    onChange={(e) => setFilterName(e.target.value)}
                    fullWidth
                    sx={!isMobile ? { flex: 1 } : {}}
                  />
                </Grid>
                 <Grid item xs={6} sm={6} md={2}>
                    <FormControl
                                  fullWidth
                                  sx={!isMobile ? { flex: 1 } : {}}
                                  variant="outlined" 
                                >
                                  <InputLabel 
                                      size="small"
                                      sx={{
                                        backgroundColor: 'background.paper', // Fondo para que no se superponga
                                        px: 1, // Pequeño padding horizontal
                                        transformOrigin: 'top left',
                                        '&.Mui-focused': {
                                          color: 'primary.main', // Color cuando está enfocado
                                        },
                                      }}
                                    >
                                      Género
                                    </InputLabel>

                                  <Select
                                    multiple
                                    sx={{
                                        "& .MuiSelect-select": {
                                          textAlign: "left"
                                        }
                                      }}
                                    size="small"
                                    value={filterGenders}
                                    onChange={(e) => setFilterGenders(e.target.value)}
                                    renderValue={(selected) => selected.join(', ')}
                                  >
                                    {genders.map((g) => (
                                      <MenuItem key={g} value={g}>
                                        <Checkbox checked={filterGenders.includes(g)} />
                                        <ListItemText primary={g} />
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                </Grid>
                 <Grid item xs={6} sm={6} md={2}>
                    <FormControl
                                  fullWidth
                                  sx={!isMobile ? { flex: 1 } : {}}
                                >
                                  <InputLabel 
                                      size="small"
                                      sx={{
                                        backgroundColor: 'background.paper', // Fondo para que no se superponga
                                        px: 1, // Pequeño padding horizontal
                                        transformOrigin: 'top left',
                                        '&.Mui-focused': {
                                          color: 'primary.main', // Color cuando está enfocado
                                        },
                                      }}
                                    >
                                      Segmentación
                                    </InputLabel>

                                  <Select
                                    multiple
                                    sx={{
                                      "& .MuiSelect-select": {
                                        textAlign: "left"
                                      }
                                    }}
                                    size="small"
                                    value={filterSegmentations}
                                    onChange={(e) => setFilterSegmentations(e.target.value)}
                                    renderValue={(selected) => selected.join(', ')}
                                  >
                                    {segmentations.map((s) => (
                                      <MenuItem key={s} value={s}>
                                        <Checkbox checked={filterSegmentations.includes(s)} />
                                        <ListItemText primary={s} />
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                </Grid>
                <Grid item xs={6} sm={6} md={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    fullWidth
                    startIcon={<AddIcon />}
                    onClick={() => {
                      setErrors({}); // Limpiar errores al abrir
                      setForm({})
                      setEditing(null)
                      setModalOpen(true)
                    }}
                  >
                    Nuevo
                  </Button>
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    fullWidth
                    startIcon={<ChatIcon />}
                    onClick={() => {
                      setErrorsMSN({}); // Limpiar errores al abrir
                      setFormMSN({})
                      setEditingMSN(null)
                      setModalMSNOpen(true)
                    }}
                  >
                    Enviar Mensaje
                  </Button>
                </Grid>
                <Grid item xs={6} sm={6} md={1} sx={{ display: 'none',  }}>
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      fullWidth
                      startIcon={<QrCodeIcon />}
                      onClick={handleClickOpen}
                    >
                      QR
                    </Button>

                    {/* <Button 
                      variant="outlined"
                      onClick={() => {
                        const canvas = document.getElementById("qr-code");
                        const pngUrl = canvas.toDataURL("image/png");
                        const downloadLink = document.createElement("a");
                        downloadLink.href = pngUrl;
                        downloadLink.download = "codigo-qr.png";
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                      }}
                    >
                      Descargar QR
                    </Button> */}

                    <Dialog open={open} onClose={handleClose}>
                      <DialogTitle>Código QR</DialogTitle>
                      <DialogContent sx={{ textAlign: 'center', padding: '20px' }}>
                        {/* <QRCode 
                          value={url} 
                          size={256} 
                          level="H" // Nivel de corrección de errores (High)
                          includeMargin={true}
                        /> */}
                        <p style={{ marginTop: '20px' }}>
                          Escanea este código para visitar: <br />
                          <a href={url} target="_blank" rel="noopener noreferrer">
                            {url}
                          </a>
                        </p>
                      </DialogContent>
                    </Dialog>
                  </div>
                </Grid>
              </Grid>
            

            

           
            
          </Box>


        {/* Tabla */}
        <TableContainer>
  <Table size={isMobile ? 'small' : 'medium'}>
    <TableHead>
      <TableRow>
        <TableCell sx={{ fontWeight: 'bold' }}>Nombres</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Teléfono</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Dirección</TableCell>
        {/* <TableCell sx={{ fontWeight: 'bold' }}>Distrito</TableCell> */}
        <TableCell sx={{ fontWeight: 'bold' }}>Segmento</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Género</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Acción</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {paginatedData.map(item => (
        <TableRow key={item.Id}>
          <TableCell>{item.Names}</TableCell>
          <TableCell>{item.Phone}</TableCell>
          <TableCell>{item.Address}</TableCell>
          {/* <TableCell>{item.AddressDistrict}</TableCell> */}
          <TableCell>{item.Segmentation}</TableCell>
          <TableCell>{item.Gender}</TableCell>
          <TableCell>
            <Box display="flex" flexDirection="row">
              <IconButton onClick={() => handleEdit(item)}><EditIcon /></IconButton>
              {/* <IconButton onClick={() => handleDelete(item.Id, item.Names)}><DeleteIcon /></IconButton> */}
              <IconButton onClick={() => confirmDelete(item)}><DeleteIcon /></IconButton>
              
            </Box>
          </TableCell>
        </TableRow>
      ))}
      {filtered.length === 0 && (
        <TableRow>
          <TableCell colSpan={7} align="center">No hay resultados</TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>

  <TablePagination
    component="div"
    count={filtered.length}
    page={page}
    onPageChange={handleChangePage}
    rowsPerPage={rowsPerPage}
    onRowsPerPageChange={handleChangeRowsPerPage}
    rowsPerPageOptions={[5, 10, 15]}
    labelRowsPerPage="Filas por página"
  />
</TableContainer>


<Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
  <DialogTitle>Confirmar eliminación</DialogTitle>
  <DialogContent>
    ¿Está seguro que desea eliminar el caserito <strong>{itemToDelete?.Names}</strong>?
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setDeleteOpen(false)}>Cancelar</Button>
    <Button variant="contained" color="error" onClick={handleConfirmDelete}>
      Eliminar
    </Button>
  </DialogActions>
</Dialog>

<Snackbar
  open={snackbarOpen}
  autoHideDuration={3000}
  onClose={() => setSnackbarOpen(false)}
  message={snackbarMessage}
/>



        {/* Modal */}
        <Dialog open={modalOpen} onClose={() => setModalOpen(false)} fullWidth>
          <DialogTitle>{editing ? 'Editar Caserito' : 'Nuevo Caserito'}</DialogTitle>
          <DialogContent>
            <TextField
              label="Nombre"
              size="small"
              fullWidth
              margin="dense"
              autoComplete="off"
              error={!!errors.FirstName}
              helperText={errors.FirstName}
              value={form.FirstName || ''}
              onChange={(e) => setForm({ ...form, FirstName: e.target.value })}
            />
            <TextField
              label="Apellido Paterno"
              size="small"
              fullWidth
              margin="dense"
              autoComplete="off"
              error={!!errors.SecondName1}
              helperText={errors.SecondName1}
              value={form.SecondName1 || ''}
              onChange={(e) => setForm({ ...form, SecondName1: e.target.value })}
            />
            <TextField
              label="Apellido Materno"
              size="small"
              fullWidth
              margin="dense"
              autoComplete="off"
              error={!!errors.SecondName2}
              helperText={errors.SecondName2}
              value={form.SecondName2 || ''}
              onChange={(e) => setForm({ ...form, SecondName2: e.target.value })}
            />
            <TextField
              label="Teléfono"
              size="small"
              fullWidth
              margin="dense"
              autoComplete="off"
              error={!!errors.Phone}
              helperText={errors.Phone}
              value={form.Phone || ''}
              onChange={(e) => setForm({ ...form, Phone: e.target.value })}
            />
            <FormControl
              fullWidth
              margin="dense"
              size="small"
              error={!!errors.Gender}
            >
              <InputLabel id="gender-label">Género</InputLabel>
              <Select
                labelId="gender-label"
                id="gender"
                value={form.Gender || ''}
                label="Género"
                onChange={(e) => setForm({ ...form, Gender: e.target.value })}
              >
                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                {genders.map(g => (
                  <MenuItem key={g} value={g}>{g}</MenuItem>
                ))}
              </Select>
              {errors.Gender && <FormHelperText>{errors.Gender}</FormHelperText>}
            </FormControl>
            <FormControl
              fullWidth
              margin="dense"
              size="small"
              error={!!errors.Segmentation}
            >
              <InputLabel id="segmentation-label">Segmentación</InputLabel>
              <Select
                labelId="segmentation-label"
                id="segmentation"
                value={form.Segmentation || ''}
                label="Segmentación"
                onChange={(e) => setForm({ ...form, Segmentation: e.target.value })}
              >
                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                {segmentations.map(g => (
                  <MenuItem key={g} value={g}>{g}</MenuItem>
                ))}
              </Select>
              {errors.Segmentation && <FormHelperText>{errors.Segmentation}</FormHelperText>}
            </FormControl>
  
            <Box display="flex" gap={1}>
              <TextField
                label="Calle"
                size="small"
                fullWidth
                margin="dense"
                autoComplete="off"
                error={!!errors.AddressStreet}
                helperText={errors.AddressStreet}
                value={form.AddressStreet || ''}
                onChange={(e) => setForm({ ...form, AddressStreet: e.target.value })}
                sx={{ flex: 4 }}
              />
              <TextField
                label="N°/Lote"
                size="small"
                fullWidth
                margin="dense"
                autoComplete="off"
                error={!!errors.AddressNumber}
                helperText={errors.AddressNumber}
                value={form.AddressNumber || ''}
                onChange={(e) => setForm({ ...form, AddressNumber: e.target.value })}
                sx={{ flex: 1 }}
              />
            </Box>

            

              {/* <Autocomplete
              freeSolo
              fullWidth
              size="small"
              options={addressOptions}
              getOptionLabel={(option) => option.label || ''}
              onInputChange={(event, newInputValue) => {
                setAddressInput(newInputValue)
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  setForm({ ...form, Address: newValue.label, AddressGeolocation: `${newValue.lat},${newValue.lon}` })
                  // También puedes guardar lat/lon si quieres
                  // setForm({ ...form, Address: newValue.label, AddressGeolocation: `${newValue.lat},${newValue.lon}` })
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Dirección"
                  margin="dense"
                  autoComplete="off"
                />
              )}
            />
            
            <TextField
              label="AddressGeolocation"
              size="small"
              fullWidth
              margin="dense"
              autoComplete="off"
              value={form.AddressGeolocation || ''}
              onChange={(e) => setForm({ ...form, AddressGeolocation: e.target.value })}
            /> */}

          </DialogContent>
          <DialogActions>
            <Button onClick={() => setModalOpen(false)}>Cancelar</Button>
            <Button variant="contained" onClick={handleSave}>Guardar</Button>
            <IconButton
            onClick={() => setModalOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          </DialogActions>

        </Dialog>

         {/* Modal */}
        <Dialog open={modalMSNOpen} onClose={() => setModalMSNOpen(false)} fullWidth>
          <DialogTitle>{editingMSN ? 'Enviar Mensaje' : 'Enviar Mensaje'}</DialogTitle>
          <DialogContent>
            
            <FormControl
                fullWidth
                margin="dense"
                size="small"
                error={!!errorsMSN.GenderMSN}
              >
                <InputLabel id="genderMSN-label">Género</InputLabel>
                <Select
                  labelId="genderMSN-label"
                  id="genderMSN"
                  multiple
                  value={formMSN.GenderMSN || []}
                  label="Género"
                  onChange={(e) => {
                    // Si se selecciona "Seleccionar todos" y no estaban todos seleccionados
                    if (e.target.value.includes("select-all")) {
                      if ((formMSN.GenderMSN || []).length === genders.length) {
                        setFormMSN({ ...formMSN, GenderMSN: [] });
                      } else {
                        setFormMSN({ ...formMSN, GenderMSN: [...genders] });
                      }
                    } else {
                      setFormMSN({ ...formMSN, GenderMSN: e.target.value });
                    }
                  }}
                  renderValue={(selected) => {
                    if (selected.length === genders.length) {
                      return "Todos";
                    }
                    return selected.join(", ");
                  }}
                >
                  {/* Opción "Seleccionar todos" */}
                  <MenuItem value="select-all">
                    <Checkbox
                      checked={(formMSN.GenderMSN || []).length === genders.length}
                      indeterminate={
                        (formMSN.GenderMSN || []).length > 0 && 
                        (formMSN.GenderMSN || []).length < genders.length
                      }
                    />
                    <ListItemText primary="todos" />
                  </MenuItem>

                  {genders.map((g) => (
                    <MenuItem key={g} value={g}>
                      <Checkbox checked={(formMSN.GenderMSN || []).includes(g)} />
                      <ListItemText primary={g} />
                    </MenuItem>
                  ))}
                </Select>
                {errorsMSN.GenderMSN && <FormHelperText>{errors.GenderMSN}</FormHelperText>}
              </FormControl>


            <FormControl
                fullWidth
                margin="dense"
                size="small"
                error={!!errorsMSN.SegmentationMSN}
              >
                <InputLabel id="segmentationMSN-label">Segmentación</InputLabel>
                <Select
                  labelId="segmentationMSN-label"
                  id="segmentationMSN"
                  multiple
                  value={formMSN.SegmentationMSN || []}
                  label="Segmentación"
                  onChange={(e) => {
                    // Si se selecciona "Seleccionar todos" y no estaban todos seleccionados
                    if (e.target.value.includes("select-all")) {
                      if ((formMSN.SegmentationMSN || []).length === segmentations.length) {
                        setFormMSN({ ...formMSN, SegmentationMSN: [] });
                      } else {
                        setFormMSN({ ...formMSN, SegmentationMSN: [...segmentations] });
                      }
                    } else {
                      setFormMSN({ ...formMSN, SegmentationMSN: e.target.value });
                    }
                  }}
                  renderValue={(selected) => {
                    if (selected.length === segmentations.length) {
                      return "Todos";
                    }
                    return selected.join(", ");
                  }}
                >
                  {/* Opción "Seleccionar todos" */}
                  <MenuItem value="select-all">
                    <Checkbox
                      checked={(formMSN.SegmentationMSN || []).length === segmentations.length}
                      indeterminate={
                        (formMSN.SegmentationMSN || []).length > 0 && 
                        (formMSN.SegmentationMSN || []).length < segmentations.length
                      }
                    />
                    <ListItemText primary="todos" />
                  </MenuItem>

                  {segmentations.map((g) => (
                    <MenuItem key={g} value={g}>
                      <Checkbox checked={(formMSN.SegmentationMSN || []).includes(g)} />
                      <ListItemText primary={g} />
                    </MenuItem>
                  ))}
                </Select>
                {errorsMSN.SegmentationMSN && <FormHelperText>{errors.SegmentationMSN}</FormHelperText>}
              </FormControl>

            
           <FormControl
  fullWidth
  margin="dense"
  size="small"
  error={!!errorsMSN.CaseritosMSN}
>
  <InputLabel id="caseritosMSN-label">Caseritos</InputLabel>
  <Select
    labelId="caseritosMSN-label"
    id="caseritosMSN"
    multiple
    value={formMSN.CaseritosMSN?.map(c => c.Names) || []} // Mostrar solo los Names en el Select
    label="Caseritos"
    onChange={(e) => {
      // Si se selecciona "Seleccionar todos"
      if (e.target.value.includes("select-all")) {
        if ((formMSN.CaseritosMSN || []).length === caseritos.length) {
          setFormMSN({ ...formMSN, CaseritosMSN: [] });
        } else {
          setFormMSN({ ...formMSN, CaseritosMSN: [...caseritos] });
        }
      } else {
        // Filtrar los caseritos seleccionados
        const selectedCaseritos = caseritos.filter(c => 
          e.target.value.includes(c.Names)
        );
        setFormMSN({ ...formMSN, CaseritosMSN: selectedCaseritos });
      }
    }}
    renderValue={(selected) => {
      if (selected.length === caseritos.length) {
        return "Todos";
      }
      return selected.join(", ");
    }}
  >
    {/* Opción "Seleccionar todos" */}
    <MenuItem value="select-all">
      <Checkbox
        checked={(formMSN.CaseritosMSN || []).length === caseritos.length}
        indeterminate={
          (formMSN.CaseritosMSN || []).length > 0 && 
          (formMSN.CaseritosMSN || []).length < caseritos.length
        }
      />
      <ListItemText primary="Todos" />
    </MenuItem>

    {caseritos.map((caserito) => (
      <MenuItem key={caserito.Id} value={caserito.Names}>
        <Checkbox 
          checked={formMSN.CaseritosMSN?.some(c => c.Id === caserito.Id) || false} 
        />
        <ListItemText 
          primary={`${caserito.Names}`} 
          // primary={`${caserito.Names} (${caserito.Phone})`} 
        />
      </MenuItem>
    ))}
  </Select>
  {errorsMSN.CaseritosMSN && <FormHelperText>{errorsMSN.CaseritosMSN}</FormHelperText>}
</FormControl>


            <TextField
              label="Mensaje"
              size="small"
              fullWidth
              margin="dense"
              multiline
              rows={5}
              autoComplete="off"
              error={!!errorsMSN.Mensaje}
              helperText={errorsMSN.Mensaje || `${formMSN.Mensaje?.length || 0}/300`}
              value={formMSN.Mensaje || ''}
              onChange={(e) => setFormMSN({ ...formMSN, Mensaje: e.target.value })}
            />

          </DialogContent>
          <DialogActions>
            <Button onClick={() => setModalMSNOpen(false)}>Cancelar</Button>
            <Button variant="contained" onClick={handleSaveMSN}>Enviar</Button>
            <IconButton
            onClick={() => setModalMSNOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          </DialogActions>

        </Dialog>
      </Box>
        </MainLayout>
  )
}
